<template>
    <div
        class="tooltip-wrapper"
        :class="{ 'is-full-width': isFullWidth }"
        :style="{ height }"
    >
        <div class="tooltip-trigger" @mouseenter="show" @mouseleave="hide">
            <slot name="trigger" />
        </div>

        <TransitionGroup name="fade">
            <div
                v-if="visible"
                class="tooltip"
                :class="[`position-${position}`, { 'from-bottom': fromBottom }]"
                :style="{ height: tooltipHeight }"
            >
                <slot />
            </div>
            <svg
                v-if="visible"
                class="tooltip-arrow"
                :class="{ 'from-bottom': fromBottom }"
                xmlns="http://www.w3.org/2000/svg"
                width="13"
                height="4"
                viewBox="0 0 13 4"
                fill="none"
            >
                <path d="M6.5 4L0.5 0H12.5L6.5 4Z" fill="#1C2026" />
            </svg>
        </TransitionGroup>
    </div>
</template>

<script setup>
import { ref, computed, onMounted, nextTick } from 'vue';

const props = defineProps({
    position: {
        type: String,
        default: 'center'
    },
    fromBottom: {
        type: Boolean,
        default: false
    },
    isFullWidth: { type: Boolean, default: false },
    height: { type: String, default: '100%' },
    tooltipHeight: { type: String, default: '40px' }
});

const visible = ref(false);
let showTimeout = null;

function show() {
    showTimeout = setTimeout(() => {
        visible.value = true;
    }, 150);
}

function hide() {
    if (showTimeout) {
        clearTimeout(showTimeout);
        showTimeout = null;
    }
    visible.value = false;
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_main.scss';
.tooltip-wrapper {
    position: relative;
    display: inline-block;

    &.is-full-width {
        width: 100%;

        .tooltip-trigger {
            display: flex;
        }
    }

    .tooltip-trigger {
        height: 100%;
        display: inline-flex;
        align-items: flex-end;
        cursor: pointer;
    }

    .tooltip-arrow {
        position: absolute;
        bottom: calc(100% + 4px);
        left: 50%;
        transform: translateX(-50%);

        &.from-bottom {
            transform: translateX(-50%) rotate(180deg);
            top: calc(100% + 4px);
        }
    }

    .tooltip {
        position: absolute;
        bottom: calc(100% + 8px) !important;
        z-index: 1000;
        pointer-events: none;
        background: $dark-background;
        color: $text-light;
        padding: 8px 12px;
        border-radius: 8px;

        &.from-bottom {
            top: calc(100% + 8px) !important;
        }

        &.position-center {
            left: 50%;
            transform: translateX(-50%);
        }

        &.position-left {
            left: 10%;
            transform: translateX(-10%);
        }

        &.position-right {
            left: 90%;
            transform: translateX(-90%);
        }
    }
}

.fade-enter-active,
.fade-leave-active {
    @include transition-default(opacity);
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
    opacity: 1;
}
</style>
